import React, { useRef, useState, useEffect } from 'react';
import { useReactToPrint } from "react-to-print";
import { ArcherContainer, ArcherElement } from 'react-archer';
import { motion } from 'framer-motion';
const PathProductBusinessAnalysis = ({ businessAnalysisData, storySpeakerSummaryResult, producedResult, salesAnalysisData, businessTransformationResult, formData }) => {
    //console.log('PRODUCED RESULT ///////')
    //console.log(producedResult);
    //console.log('PRODUCED RESULT ///////')
    // console.log('BUSINESS ANALYSIS DATA ///////')
    // console.log(businessAnalysisData);
    // console.log('BUSINESS ANALYSIS DATA ///////')
    // console.log('STORY SPEAKER SUMMARY RESULT (with Why) ///////')
    // console.log(storySpeakerSummaryResult);
    // console.log('STORY SPEAKER SUMMARY RESULT (with Why) ///////')
    // console.log('SALES ANALYSIS DATA ///////')
    // console.log(salesAnalysisData);
    // console.log('SALES ANALYSIS DATA ///////')
    // console.log('BUSINESS TRANSFORMATION RESULT ///////')
    // console.log(businessTransformationResult);
    // console.log('BUSINESS TRANSFORMATION RESULT ///////')
    if (!businessAnalysisData || !storySpeakerSummaryResult) return null;

    const storySummaryRef = useRef(null);
    const [isRendered, setIsRendered] = useState(false); // State to track initial render stabilization

    // Effect to update state after a short delay, allowing layout to stabilize
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsRendered(true);
        }, 100); // 100ms delay, can be adjusted

        return () => clearTimeout(timer); // Cleanup timer on component unmount
    }, []); // Empty dependency array ensures this runs only once after mount

    const handlePrint = useReactToPrint({
        //content: () => storySummaryRef.current,
        contentRef: storySummaryRef,
        documentTitle: 'StoryPath_' + (formData.promptCustomerName || 'Customer').replace(/ /g, '_') + '_Summary_Story_' + (producedResult?.title?.title || 'Product').replace(/ /g, '_') + '_' + new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' }),
        onBeforeGetContent: () => {
            if (!storySummaryRef.current) {
                throw new Error('Content not ready for printing');
            }
            //console.log('Preparing content for print...');
        },
        onAfterPrint: () => {
            //console.log('Printing complete');
        },
        onPrintError: (error) => {
            //console.error('Print failed:', error);
        }
    });

    // Helper function to render "Why" items
    const renderWhyItems = (items, title, iconSrc, iconAlt, titleColor, elementId) => {
        if (!items || items.length === 0) return null;
        return (
            <ArcherElement id={elementId}>
                <div className="mb-12">
                    <div className="flex items-start gap-3 mb-3">
                        <div className={`flex-shrink-0 ${titleColor}/20 p-2 rounded-lg`}>
                            <img src={iconSrc} className="h-5 w-5" alt={iconAlt} />
                        </div>
                        <h4 className={`text-${titleColor} font-medium text-lg print:text-base`}>{title}</h4>
                    </div>
                    <ul className="list-disc pl-8 space-y-3 text-sm text-zinc-300 ml-4 print:text-xs">
                        {items.map((item, idx) => (
                            <li key={idx}>{item.name}</li>
                        ))}
                    </ul>
                </div>
            </ArcherElement>
        );
    };




    const studies = storySpeakerSummaryResult?.openingWhy || storySpeakerSummaryResult?.middleWhy || storySpeakerSummaryResult?.closingWhy;

    if (!Array.isArray(studies) || studies.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-zinc-400 p-8 text-center min-h-[calc(100vh-10rem)] bg-zinc-950">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-16 h-16 mb-4 text-zinc-500">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                </svg>
                <h3 className="text-xl font-semibold text-zinc-200 mb-2">No Supporting Points Available</h3>
                <p className="text-zinc-400">There are currently no supporting points to display.</p>
            </div>
        );
    }


    return (
        <div className=" space-y-6 overflow-y-auto h-[calc(100vh-8rem)] w-full pr-8  pb-20"

        >
            <motion.button
                onClick={handlePrint}
                className="bg-zinc-800 absolute top-4 right-20 z-50 text-white px-3 py-2 rounded-lg flex items-center gap-2 print:hidden"
                whileHover={{ backgroundColor: "rgb(82 82 91)", scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                transition={{ duration: 0.2 }}
            >
                <img src={'/util/app/b3-admin-export.svg'} className='h-5 w-5' />
                <span>pdf</span>
            </motion.button>

            {storySpeakerSummaryResult && (
                <ArcherContainer
                    key={isRendered} // Add key to force re-render when isRendered becomes true
                    strokeColor="rgb(113 113 122)"
                    strokeWidth={1}
                    strokeDasharray="5,5"
                    endMarker={false}
                 >
                    <div ref={storySummaryRef}>


                        {/* <div className='print:block hidden'>
                            <img
                                src="/util/app/StoryPath-Logo-Print.png"
                                className="h-8 absolute bottom-14 left-14"
                                alt="StoryPath Logo"
                            />
                        </div> */}
                        <div className="ml-4 flex rounded-lg print:p-14">

                            <div className="w-2/3 pr-8 pl-8 print:w-2/3 print:pr-4 print:pl-4 print:pt-4">
                                <div className='mt-4 pb-4'>
                                    <div className='text-zinc-100 font-normal text-4xl print:text-2xl'>{producedResult?.title?.title}</div>
                                    <div className='text-zinc-300 font-normal text-xl mt-2 print:text-base'>{producedResult?.title?.subtitle}</div>
                                </div>

                                <div className=" pt-8 print:pt-4">
                                    {/* <div className="text-green-300  text-xl font-medium print:text-base">
                                        Story Summary
                                    </div> */}
                                    {/* <div className='border-l border-sky-400 p-4 pl-8 pt-0 mt-8 '> */}
                                    <div className=' pt-0'>
                                        {storySpeakerSummaryResult.opening && (
                                            <ArcherElement
                                                id="currentState"
                                                relations={[{
                                                    targetId: 'currentStateDrivers',
                                                    targetAnchor: 'left',
                                                    sourceAnchor: 'right',
                                                    style: { strokeColor: 'rgb(252 165 165)', endMarker: true }
                                                }]}
                                            >
                                                <div className='mr-12 pr-8'>
                                                    <div className="flex items-start gap-4 mt-4">
                                                        <div className="flex-shrink-0 bg-red-300/20 p-3 rounded-lg">
                                                            <img src="/util/app/b3-admin-story-current.svg" className="h-6 w-6" alt="Current State" />
                                                        </div>
                                                        <div className="flex-1">
                                                            <p className="text-red-300 text-xl font-medium print:text-base">
                                                                Current State
                                                            </p>
                                                            <p className="text-zinc-300 text-normal leading-relaxed mt-2 print:text-sm print:leading-relaxed">
                                                                {storySpeakerSummaryResult.opening}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ArcherElement>
                                        )}
                                        {storySpeakerSummaryResult.middle && (
                                            <ArcherElement
                                                id="transformation"
                                                relations={[{
                                                    targetId: 'transformationEnablers',
                                                    targetAnchor: 'left',
                                                    sourceAnchor: 'right',
                                                    style: { strokeColor: 'rgb(125 211 252)', endMarker: true }
                                                }]}
                                            >
                                                <div className='mt-12 mr-12 pr-8'>
                                                    <div className="flex items-start gap-4">
                                                        <div className="flex-shrink-0 bg-sky-300/20 p-2 rounded-lg">
                                                            <img src="/util/app/b3-admin-story-transform-2.svg" className="h-7 w-7" alt="Transformation" />
                                                        </div>
                                                        <div className="flex-1">
                                                            <p className="text-sky-300 text-xl font-medium print:text-base">
                                                                Transformation
                                                            </p>
                                                            <p className="text-zinc-300 text-normal leading-relaxed mt-2 print:text-sm print:leading-relaxed">
                                                                {storySpeakerSummaryResult.middle}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ArcherElement>
                                        )}
                                        {storySpeakerSummaryResult.closing && (
                                            <ArcherElement
                                                id="futureState"
                                                relations={[{
                                                    targetId: 'futureStateBenefits',
                                                    targetAnchor: 'left',
                                                    sourceAnchor: 'right',
                                                    style: { strokeColor: 'rgb(134 239 172)', endMarker: true }
                                                }]}
                                            >
                                                <div className='mt-12 mr-12 pr-8'>
                                                    <div className="flex items-start gap-4">
                                                        <div className="flex-shrink-0 bg-green-300/20 p-3 rounded-lg">
                                                            <img src="/util/app/b3-admin-story-future-3.svg" className="h-6 w-6" alt="Future State" />
                                                        </div>
                                                        <div className="flex-1">
                                                            <p className="text-green-300 text-xl font-medium print:text-base">
                                                                Future State
                                                            </p>
                                                            <p className="text-zinc-300 text-normal leading-relaxed mt-2 print:text-sm print:leading-relaxed">
                                                                {storySpeakerSummaryResult.closing}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ArcherElement>
                                        )}
                                    </div>
                                    {/* <div className='mt-8'>
                                    <div className='text-zinc-200 text-xl font-medium'>
                                        Business Analysis
                                    </div>
                                </div> */}
                                </div>



                            </div>

                            {/* <div className="w-1/4 px-4 print:hidden">
                                 {salesAnalysisData?.valueProposition && (
                                    <div className="rounded bg-black/20 h-full pb-12 rounded-lg p-6 mt-4">
                                        <h4 className="text-sky-300 font-medium text-xl mb-4 print:text-lg">Value Proposition</h4>
                                        <div className="grid grid-cols-1 gap-6 ml-0">
                                        
                                            <div>
                                                {salesAnalysisData.valueProposition.keyMessages && salesAnalysisData.valueProposition.keyMessages.length > 0 && (
                                                    <>
                                                        <h4 className="text-zinc-100 mt-4 font-medium mb-4 print:text-base">Key Messages</h4>
                                                        <ul className="list-disc pl-4 space-y-4 print:text-xs text-sm text-zinc-300">
                                                            {salesAnalysisData.valueProposition.keyMessages.map((message, idx) => (
                                                                <li key={idx}>{message}</li>
                                                            ))}
                                                        </ul>
                                                    </>
                                                )}

                                                {salesAnalysisData.valueProposition.uniqueValue && salesAnalysisData.valueProposition.uniqueValue.length > 0 && (
                                                    <>
                                                        <h4 className="text-zinc-100 font-medium mt-12 mb-4 print:text-base">Unique Value</h4>
                                                        <ul className="list-disc pl-4 space-y-4 print:text-xs text-sm text-zinc-300">
                                                            {salesAnalysisData.valueProposition.uniqueValue.map((value, idx) => (
                                                                <li key={idx}>{value}</li>
                                                            ))}
                                                        </ul>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div> */}

                            <div className="w-1/3 pl-8 pt-12 prxint:hidden">
                                <div className="rounded bg-black/20 h-full  pt-12  rounded-lg p-6 mt-4 ">
                                    <h3 className="text-zinc-100 font-normal text-2xl ml-12 mb-6 print:text-lg">Supporting Points</h3>
                                    {renderWhyItems(storySpeakerSummaryResult.openingWhy, "Current State Drivers", "/util/app/b3-admin-story-current.svg", "Current State Why", "red-300", "currentStateDrivers")}
                                    {renderWhyItems(storySpeakerSummaryResult.middleWhy, "Transformation Enablers", "/util/app/b3-admin-story-transform-2.svg", "Transformation Why", "sky-300", "transformationEnablers")}
                                    {renderWhyItems(storySpeakerSummaryResult.closingWhy, "Future State Benefits", "/util/app/b3-admin-story-future-3.svg", "Future State Why", "green-300", "futureStateBenefits")}
                                </div>
                            </div>

                        </div>


                    </div>
                </ArcherContainer>
            )}



        </div>
    );
};

export default PathProductBusinessAnalysis;